var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.502 11.733v17.115c2.25-1.483 5.53-5.979 6.362-8.533-.832-2.523-4.112-7.088-6.363-8.582zm1.46 3.398a22.401 22.401 0 013.372 5.173c-.874 1.865-2 3.601-3.35 5.157l-.021-10.33zM8.955 20.299A10.272 10.272 0 0019.237 30.58a7.553 7.553 0 004.304-1.152v-5.141a7.237 7.237 0 01-3.856 1.344 5.332 5.332 0 01-5.525-5.333c0-2.96 2.299-5.28 5.525-5.28a7.067 7.067 0 013.856 1.296V11.2a8.044 8.044 0 00-4.304-1.168A10.32 10.32 0 008.955 20.299z"
  })));
}
export default SvgSmart;